import { Component } from '@angular/core';

@Component({
  selector: 'rs-turn-on-router',
  templateUrl: 'turn-on-router.component.html',
  styleUrls: ['turn-on-router.component.scss']
})
export class TurnOnRouterComponent {}
